import React from 'react';
import { connect } from 'react-redux';
import * as actions from 'store/actions/index';

import classes from './ChapterPlayer.module.scss';
import ButtonStyle from 'Flow2/components/UI/Button/Button.module.scss';
import Swal from 'sweetalert2';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage, faSearchPlus } from '@fortawesome/free-solid-svg-icons';
import { injectIntl } from 'react-intl';

import parse from 'html-react-parser';


import TimeComments from 'Flow2/components/Article/TimeComments/TimeComments';

export const CHAPTER_MARK = "chapter";
export const CHAPTER_LANG = "en";

class ChapterPlayer extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            timeComments: this.props.timeComments
        };
    }
    
    componentDidUpdate(prevProps) {
        if (prevProps.timeComments != this.props.timeComments) {
            this.initChapters();
        }
    }
    
    // create chapter list to send to wrapped component
    initChapters = () => {
        let clipTimeComments = { ...this.props.timeComments };
        
        if(clipTimeComments.clipId) {
            const timeComments = { ...clipTimeComments.data };
            
            for(let key in timeComments) {
                timeComments[key].name !== CHAPTER_LANG && delete timeComments[key];
            }

            clipTimeComments.data = timeComments;
        }
        
        this.setState({ timeComments: clipTimeComments });
    }
    
    hasThumb = (time) => {
        return this.props.thumbs[CHAPTER_MARK + time] ? true : false;
    }
    
    hasTime = (time, data = {}) => {
        const values = Object.values(data);
        for(let key in data) {
            if(data[key].tcin && data[key].tcin == time) {
                return true;
            }
        }
        return false;
    }
    
    onAdd = (addedEntry) => {
        const time = addedEntry.tcin ? addedEntry.tcin : '0.0';
        
        if(this.hasTime(time, this.state.timeComments.data)) {
            this.showExist();
            return {};
        }
        
        this.props.addThumb(this.props.clip.id, time);
        return { ...addedEntry, type: CHAPTER_MARK, name: CHAPTER_LANG };
    }
    
    onDelete = (item) => {
        // delete reference chapters (with other lang)
        const chapters = this.props.timeComments.data;
        for(let key in chapters) {
            if(chapters[key].name !== CHAPTER_LANG && chapters[key].tcin === item.tcin) {
                this.props.deleteRefChapter(chapters[key].id);
            }
        }
        
        this.deleteThumb(item);
    }
    
    deleteThumb = (item) => {
        if(this.hasThumb(item.tcin)) {
            this.props.thumbs[CHAPTER_MARK + item.tcin].forEach(mediafile => {
                this.props.deleteThumb(mediafile.id, this.props.clip.id);
            });
        }
    }
    
    replaceThumb = (item) => {
        const { clipId, currentTarget } = this.props.timeCurrentObj;
        const time = (currentTarget && currentTarget.currentTime) ? currentTarget.currentTime.toFixed(1) : '0.0';
        
        this.props.addThumb(item.clipid, time, item.tcin);
        
        this.deleteThumb(item);
    }
    
    getAdditionalControls = (item) => {
        return (
            <div className="custom-rounded" onClick={() => this.replaceThumb(item)}><FontAwesomeIcon icon={faImage} title={this.props.intl.formatMessage({ id: "timecomments.thumb.replace" })}/></div>
            
        )
    }
    
    showThumb = (src) => {
        Swal.fire({
            confirmButtonText: this.props.intl.formatMessage({ id: "common.close" }),
            confirmButtonClass: [ButtonStyle.Button, ButtonStyle.Red].join(' '),
            buttonsStyling: false,
            width: '50%',
            html: '<div class="ChapterPlayerThumbPreview"><img src="'+src+'" /></div>'
        });
    }
    
    showExist = () => {
        Swal.fire({
            confirmButtonText: this.props.intl.formatMessage({ id: "common.close" }),
            confirmButtonClass: [ButtonStyle.Button, ButtonStyle.Red].join(' '),
            buttonsStyling: false,
            text: this.props.intl.formatMessage({ id: "popup.timecomment.chapter.exist" })
        });
    }
    
    getThumb = (item) => {
        if(this.hasThumb(item.tcin)) {
            let src = this.props.thumbs[CHAPTER_MARK + item.tcin][0].getUrl();
            return (
                <div className={classes.Thumb} onClick={() => this.showThumb(src)}>
                    <img src={src} />
                    <div className={classes.ThumbZoom}>
                        <FontAwesomeIcon icon={faSearchPlus} />
                    </div>
                </div>
            );
        }
        
        return (
            <div className={classes.Thumb}></div>
        );
    } 

    render = () => {
        return (
            <TimeComments 
                { ...this.props } 
                onAdd={this.onAdd}
                onDelete={this.onDelete}
                getAdditionalControls={this.getAdditionalControls} 
                getThumb={this.getThumb}
                type={CHAPTER_MARK}
                timeComments={this.state.timeComments} />
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const thumbs = {};
    
    if(ownProps.clip && ownProps.clip.mediafiles) {
        ownProps.clip.mediafiles.forEach(mediafile => {
            let tags = mediafile.getTags();
            if(tags && tags.indexOf(CHAPTER_MARK) !== -1) {
                let match = tags.match(/chapter\d+\.\d+?/g);
                if(match && match.length) {
                    if(!thumbs[match[0]]) {
                        thumbs[match[0]] = [];
                    }
                    
                    thumbs[match[0]].push(mediafile);
                }
            }
        });
    }
    
    return {
        timeComments: state.comment.clipTimeComments,
        timeCurrentObj: state.comment.clipTimeCurrent,
        thumbs: thumbs
    }
}

const mapDispatchToProps = dispatch => ({
    addThumb: (clipId, time, chapter) => dispatch(actions.addThumb(clipId, time, chapter)),
    deleteThumb: (id, clipId) => dispatch(actions.deleteMediaFile(id, clipId)),
    deleteRefChapter: (id) => dispatch(actions.deleteRefChapter(id))
});


export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ChapterPlayer));
